import styled from "styled-components";

export const MenuLogo = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
    margin-bottom: 8px;
`;

export const MenuMobLogo = styled.img`
    height: 36px;
    width: auto;
    object-fit: contain;
`;

export const DrawerLogo = styled.img`
    height: 32px;
    width: auto;
    object-fit: contain;
`;

export const CollapsedIcon = styled.img`
    width: 36px;
    height: 36px;
    object-fit: contain;
`;